import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"
import { CheckCircle2, XCircle, AlertTriangle, Info, Loader2 } from "lucide-react"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <CheckCircle2 className="w-5 h-5 text-petrol" strokeWidth={2} />,
        error: <XCircle className="w-5 h-5 text-wine" strokeWidth={2} />,
        warning: <AlertTriangle className="w-5 h-5 text-muted_gold" strokeWidth={2} />,
        info: <Info className="w-5 h-5 text-soft_muted" strokeWidth={2} />,
        loading: <Loader2 className="w-5 h-5 text-soft_muted animate-spin" strokeWidth={2} />,
      }}
      toastOptions={{
        classNames: {
          toast: [
            "group toast",
            "font-sans text-sm",
            "bg-bone border border-soft_border",
            "text-graphite",
            "rounded-xl",
            "shadow-soft",
            "px-4 py-3",
            "min-w-[320px] max-w-[420px]",
          ].join(" "),
          title: "font-sans font-semibold text-graphite text-sm leading-snug",
          description: "font-sans text-soft_muted text-xs mt-0.5 leading-relaxed",
          success: [
            "bg-bone border border-soft_border",
            "[&>[data-icon]]:text-petrol",
          ].join(" "),
          error: [
            "bg-bone border border-soft_border",
            "[&>[data-icon]]:text-wine",
          ].join(" "),
          warning: [
            "bg-bone border border-soft_border",
            "[&>[data-icon]]:text-muted_gold",
          ].join(" "),
          info: [
            "bg-bone border border-soft_border",
            "[&>[data-icon]]:text-soft_muted",
          ].join(" "),
          loading: [
            "bg-bone border border-soft_border",
            "[&>[data-icon]]:text-soft_muted",
          ].join(" "),
          closeButton: [
            "bg-stone border border-soft_border text-soft_muted",
            "hover:bg-soft_border hover:text-graphite",
            "rounded-lg transition-colors",
          ].join(" "),
          actionButton: [
            "bg-petrol text-bone font-sans font-medium text-xs",
            "rounded-lg px-3 py-1.5",
            "hover:bg-petrol-hover transition-colors",
          ].join(" "),
          cancelButton: [
            "bg-stone text-soft_muted font-sans font-medium text-xs",
            "rounded-lg px-3 py-1.5",
            "hover:bg-soft_border hover:text-graphite transition-colors",
          ].join(" "),
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
